/** sessionStorage key: last registry visited in this tab (for gift-flow exit) */
export const REGISTRY_RETURN_SLUG_KEY = 'gg_registry_return_slug';

export function setRegistryReturnSlug(slug) {
    if (!slug || typeof sessionStorage === 'undefined') {
        return;
    }
    try {
        sessionStorage.setItem(REGISTRY_RETURN_SLUG_KEY, slug);
    } catch (e) {
        // private browsing / quota — ignore
    }
}

export function getRegistryReturnSlug() {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }
    try {
        return sessionStorage.getItem(REGISTRY_RETURN_SLUG_KEY);
    } catch (e) {
        return null;
    }
}
